import { Lang } from '@debbie/common/dist/lang/Lang.js';
import CzechishFlag from './CzechishFlag.js';
import DanishFlag from './DanishFlag.js';
import DutchFlag from './DutchFlag.js';
import FinnishFlag from './FinnishFlag.js';
import FrenchFlag from './FrenchFlag.js';
import GermanFlag from './GermanFlag.js';
import GreekFlag from './GreekFlag.js';
import NorwegianFlag from './NorwegianFlag.js';
import SpanishFlag from './SpanishFlag.js';
import SwedishFlag from './SwedishFlag.js';
import UnitedKingdomFlag from './UnitedKingdomFlag.js';
/** Round flag icons for the languages the platform is translated to */
export const languageFlags = {
    [Lang.en]: UnitedKingdomFlag,
    [Lang.da]: DanishFlag,
    [Lang.sv]: SwedishFlag,
    [Lang.no]: NorwegianFlag,
    [Lang.fi]: FinnishFlag,
    [Lang.nl]: DutchFlag,
    [Lang.de]: GermanFlag,
    [Lang.fr]: FrenchFlag,
    [Lang.es]: SpanishFlag,
    [Lang.cs]: CzechishFlag,
    [Lang.el]: GreekFlag,
};
//# sourceMappingURL=flags.js.map